import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GIQError } from 'src/app/core/errors/giq-error';
import { withErrorMapping } from 'src/app/core/errors/with-error-mapping';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AccessService {
  constructor(private httpClient: HttpClient) {}

  public access(identifier: string, type: string) {
    if (identifier != null && type != null) {
      this.httpClient
        .post<any>(environment.apiUrl + `/reports/access`, { identifier, type })
        .pipe(withErrorMapping)
        .subscribe({
          error: (err: GIQError) => {
            console.log(err);
          },
        });
    }
  }
}
